var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcCustomer = function SvgIcCustomer(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F8D822",
    fillRule: "nonzero",
    d: "M6.625 8.5a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5zM15 7.438a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141103",
    fillRule: "nonzero",
    d: "M12.625 16.938H.75a.75.75 0 0 1-.75-.75 6.687 6.687 0 1 1 13.375 0 .75.75 0 0 1-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141103",
    d: "M14.935 14.506h4.326c.43 0 .645-.284.645-.853 0-.853-.69-4.647-4.75-4.647-1.847 0-2.752.636-2.753 1.362 0 .226.225.539.678.94.347.381.656.854.926 1.419.21.437.354.892.435 1.363a.5.5 0 0 0 .493.416z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCustomer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-customer.f31f550f.svg";
export { ForwardRef as ReactComponent };